module.exports = __webpack_public_path__ + "static/floodalert-c93684c924d26df53ded9ba6d763e97d.png";